import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-filedownload',
    template: `
    <button title="Download" [disabled]="NotContainFilePath" (click)="docdownload($event);"
            class="btn btn-outline btn-primary btn-rounded btn-sm waves-effect waves-light" style="padding: .3rem .8rem;margin-top:0rem">
      <i class="fas fa-download"></i>
    </button>`,
    standalone: false
})
export class DynamicscreendFileDownload implements ICellRendererAngularComp {

  params;
  label: string;
  NotContainFilePath = true
  permissions: number[] = [];

  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
    let s3FilePath = this.params.value
    if (s3FilePath != '' && s3FilePath != null && s3FilePath != undefined) {
      this.NotContainFilePath = false
    }
  }
  



  refresh(params?: any): boolean {
    return true;
  }

  docdownload($event) {
    console.log("hello")
    if (this.params.docdownload instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        fieldValue:this.params.value
        // ...something
      }
      console.log(params)
      this.params.docdownload(params);

    }
  }
}
